import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import ITR from './Container/ITR/ITR';
import GST from './Container/GST/GST';
import Telco from './Container/Telco/Telco';
import Perfios from './Container/Perfios/Perfios';
import PerfiosCallback from './Container/PerfiosCallback/PerfiosCallback';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Route component={ITR} path='/itr' exact />
      <Route component={GST} path='/gst' exact />
      <Route component={Telco} path='/mobile_verification_service' exact />
      <Route component={PerfiosCallback} path='/banking/transaction-callback' exact />
      <Route component={Perfios} path='/banking' exact />
    </BrowserRouter>
  );
}

export default App;
